import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage, makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import type {
    GetConnectedFormsDashboard_connectedFormsDashboard as ConnectedFormsDashboard,
    GetConnectedFormsDashboard as GetConnectedFormsDashboardQuery,
    GetConnectedFormsDashboardVariables as GetConnectedFormsDashboardQueryVariables,
    DashboardInput,
} from 'nutshell-graphql-types';

import GET_CONNECTED_FORMS_DASHBOARD from '../queries/get-connected-forms-dashboard.graphql';

export const useGetConnectedFormsDashboard = (
    input: DashboardInput
): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    connectedFormsDashboard: ConnectedFormsDashboard;
} => {
    const {loading, data, error} = useQuery<
        GetConnectedFormsDashboardQuery,
        GetConnectedFormsDashboardQueryVariables
    >(GET_CONNECTED_FORMS_DASHBOARD, {
        variables: {input},
        notifyOnNetworkStatusChange: true,
    });

    const {connectedFormsDashboard} = makeDataDangerous(data);

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        connectedFormsDashboard,
    };
};
